export const styles = {
  root: {
    marginTop: 5,
    marginBottom: 5,
    marginLeft: 'auto',
    marginRight: 'auto',
    '& >:first-of-type': {
      section: {
        borderTopLeftRadius: 50,
        borderTopRightRadius: 50,
      },
    },
    '& >:last-of-type': {
      section: {
        borderBottomLeftRadius: 50,
        borderBottomRightRadius: 50,
      },
    },
  },
};
